import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Tooltip,
  Card,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledButton,
  OutlinedIconFab,
  theme,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import Suggestions from "../Utils/Suggestions";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Icon from "../Utils/Icons";
import { DiagnosisTable } from "./DiagnosisTable";
import { durationType } from "../initialData/initialData";

const Diagnosis = ({
  sectionName,
  activeSection,
  suggestions,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  data,
  setData,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Inside Diagnosis", data);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalledDiagnosis, setDebounceFunctionCalledDiagnosis] =
    useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const [newDiagnosis, setNewDiagnosis] = useState({
    term: "",
    clinical_note: "",
    duration: "",
    durationType: "days",
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [diagnosisName, setDiagnosisName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [diagnosis, setDiagnosis] = useState(data);
  const [validationErrors, setValidationErrors] = useState({
    term: "",
    duration: "",
  });
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);
  const [suggestionClicked, setSuggestionClicked] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);

  useEffect(() => {
    setDiagnosis(data);
  }, [data]);

  useEffect(() => {
    if (!newDiagnosis.durationType) {
      setNewDiagnosis((prev) => ({
        ...prev,
        durationType: "days",
      }));
    }
  }, [newDiagnosis.durationType]);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  useEffect(() => {
    // alert(`DH ${activeHistorySection}`);
    if (activeSection) {
      let timerId;

      timerId = setTimeout(() => {
        setDiagnosisName(transcript);
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [transcript]);

  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when diagnosisName changes

    let timerOut = setTimeout(() => {
      if (diagnosisName.trim() !== "") {
        debouncedFilterCall(diagnosisName.toLowerCase());
      }
    }, 500);
    return () => clearInterval(timerOut);
  }, [diagnosisName]);

  const startListening = (key) => {
    // alert("MH SL");
    if (transcript) {
      resetTranscript();
    }
    // setActiveHistorySection("Family History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
  };
  const debouncedFilterCall = async (name) => {
    console.log("Debounce function called");
    let semanticTagForDiagnosis = "disorder";
    const postBody = {
      term: name,
      state: "active",
      semantictag: semanticTagForDiagnosis,
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (diagnosisName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((medicineItem) => {
              return {
                term: medicineItem.term,
                // id: medicineItem.conceptId,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              if (diagnosisName.length > 1) {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBody,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);
                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;
                    setAutoCompleteData(dataToProcess);
                    setFilteredOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredOptions([]);
                  }
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalledDiagnosis(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const validateFields = () => {
    const errors = {};

    if (!newDiagnosis.term && diagnosisName.length === 0) {
      errors.term = "Diagnosis Name is a mandatory field.";
    }

    setValidationErrors((prev) => ({
      ...prev,
      term: errors.term || "",
    }));

    return Object.keys(errors).length === 0; // Return true if no errors
  };
  // Function to handle adding a new row
  const handleAdd = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }
    if (validationErrors.duration) {
      return;
    }

    let newDetails,
      updatedFound = {},
      updatedSelectedOptiondetsils = {},
      foundData = false;

    if (!optionChosen.current) {
      const postBody = {
        term: diagnosisName,
        state: "active",
        semantictag: "disorder",
        acceptability: "synonyms",
        returnlimit: "100",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: true,
      };

      try {
        if (diagnosisName.length > 1) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
            postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === diagnosisName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: diagnosisName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: diagnosisName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: diagnosisName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: diagnosisName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            if (foundData) {
              console.log("updatedFound", updatedFound);
              newDetails = {
                ...newDiagnosis,
                term: updatedFound.term,
                id: updatedFound.id,
              };
            } else {
              console.log(
                "updatedSelectedOptiondetsils",
                updatedSelectedOptiondetsils
              );
              newDetails = {
                ...newDiagnosis,
                term: updatedSelectedOptiondetsils.term,
                id: updatedSelectedOptiondetsils.id,
              };
            }
          } else {
            newDetails = {
              ...newDiagnosis,
              term: diagnosisName,
              id: null,
            };
          }
        }
      } catch (err) {
        console.log(err);
        // toast.error(err);
        newDetails = {
          ...newDiagnosis,
          term: diagnosisName,
          id: null,
        };
      }
    } else {
      newDetails = { ...newDiagnosis };
    }

    console.log("New Diagnosis Added", newDetails);

    const normalizedDetails = {
      ...newDetails,
      durationType: newDetails.duration ? newDetails.durationType : "",
    };

    // Add the new term to the complaints list
    let updatedDetails = [...diagnosis, normalizedDetails];
    console.log("Diagnosis Updated Details", updatedDetails);
    setDiagnosis(updatedDetails);
    setNewDiagnosis({
      term: "",
      clinical_note: "",
      duration: "",
      durationType: "days",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setDebounceFunctionCalledDiagnosis(false);
    setTermSelectedOrAdded(false);
    setDiagnosisName("");
    setData(updatedDetails);
    optionChosen.current = false;
    setFilteredOptions([]);
  };

  // Function to handle input changes
  const handleInputChange = (field, value) => {
    if (field == "term") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
    }

    let newDetails = {
      ...newDiagnosis,
      [field]: value,
    };

    if (field === "duration") {
      const floatValue = parseFloat(value);
      const intValue = parseInt(value, 10);

      if ((floatValue && isNaN(floatValue)) || floatValue <= 0) {
        setValidationErrors((prev) => ({
          ...prev,
          duration: "Duration must be a positive integer",
        }));
      } else if (floatValue && floatValue !== intValue) {
        setValidationErrors((prev) => ({
          ...prev,
          duration: "Duration must be a positive integer",
        }));
      } else {
        setValidationErrors((prev) => ({
          ...prev,
          duration: "",
        }));
      }
    }

    setNewDiagnosis(newDetails);
  };

  // Function to handle row edit
  const handleEditRow = (index) => {
    setDiagnosisName(diagnosis[index].term);
    setNewDiagnosis({ ...diagnosis[index], term: "" });
    setEditingIndex(index);
    // handleDeleteRow(index); // Remove the row from the list temporarily
  };
  console.log("Editing Index", editingIndex);
  const handleUpdate = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }
    if (validationErrors.duration) {
      return;
    }

    let newDetails,
      updatedFound = {},
      updatedSelectedOptiondetsils = {},
      foundData = false;

    if (!optionChosen.current) {
      const postBody = {
        term: diagnosisName,
        state: "active",
        semantictag: "disorder",
        acceptability: "synonyms",
        returnlimit: "100",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: true,
      };

      try {
        if (diagnosisName.length > 1) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
            postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === diagnosisName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: diagnosisName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: diagnosisName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: diagnosisName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: diagnosisName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            if (foundData) {
              console.log("updatedFound", updatedFound);
              newDetails = {
                ...newDiagnosis,
                term: updatedFound.term,
                id: updatedFound.id,
              };
            } else {
              console.log(
                "updatedSelectedOptiondetsils",
                updatedSelectedOptiondetsils
              );
              newDetails = {
                ...newDiagnosis,
                term: updatedSelectedOptiondetsils.term,
                id: updatedSelectedOptiondetsils.id,
              };
            }
          } else {
            newDetails = {
              ...newDiagnosis,
              term: diagnosisName,
              id: null,
            };
          }
        }
      } catch (err) {
        console.log(err);
        // toast.error(err);
        newDetails = {
          ...newDiagnosis,
          term: diagnosisName,
          id: null,
        };
      }
    } else {
      newDetails = { ...newDiagnosis };
    }

    newDetails = { ...newDetails, source: undefined };

    const normalizedDetails = {
      ...newDetails,
      durationType: newDetails.duration ? newDetails.durationType : "",
    };

    let updatedDetails = diagnosis.map((data, i) =>
      i == editingIndex ? normalizedDetails : data
    );
    setDiagnosis(updatedDetails);
    setEditingIndex(null);
    setNewDiagnosis({
      term: "",
      clinical_note: "",
      duration: "",
      durationType: "days",
    });
    setDebounceFunctionCalledDiagnosis(false);
    setTermSelectedOrAdded(false);
    setDiagnosisName("");
    setData(updatedDetails);
    setFilteredOptions([]);
    optionChosen.current = false;
  };
  // Function to handle row delete
  const handleDeleteRow = (index) => {
    let updatedDetails = diagnosis.filter((_, i) => i !== index);
    setDiagnosis(updatedDetails);
    setData(updatedDetails);
  };
  const memoizedHandleCrossButtonClick = useCallback(
    (sectionName, suggestionName, type) => {
      handleCrossButtonClick(sectionName, suggestionName, type);
    },
    [handleCrossButtonClick]
  );
  const handleClearDiagnosisName = () => {
    setValidationErrors({});
    setDiagnosisName("");
    resetTranscript();
    setNewDiagnosis({
      ...newDiagnosis,
      term: "", // Use computed property name to set the field dynamically
      duration: "",
      durationType: "days",
    });
    setFilteredOptions([]);
    setAutoCompleteData([]);
    setDebounceFunctionCalledDiagnosis(false);
    setTermSelectedOrAdded(false);
    // setMedicineList([])
  };
  const handleAddOption = async (term) => {
    if (term.trim().length == 0) {
      const errors = {};
      errors.term = "You can't add an empty string";
      setValidationErrors(errors);
      return;
    }
    const postBody = {
      term: term,
      state: "active",
      semantictag: "disorder",
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (diagnosisName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          let updatedFound = {},
            updatedSelectedOptiondetsils = {},
            foundData = false;
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            foundData = response.data.data.find((d) => d.term === term);
            console.log("Found Data", foundData);
            if (foundData) {
              updatedFound = {
                ...foundData,
                found: true,
                id: foundData.conceptId,
              };
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: term,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: term,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }
          } else {
            updatedSelectedOptiondetsils = {
              hierarchy: null,
              isPreferredTerm: null,
              conceptState: null,
              conceptFsn: term,
              definitionStatus: null,
              conceptId: null,
              languageCode: "en",
              typeId: null,
              term: term,
              caseSignificanceId: "CASE_INSENSITIVE",
              id: null,
              effectiveTime: null,
              activeStatus: null,
              moduleId: null,
            };
          }

          setAutoCompleteData([]);
          setFilteredOptions([]);
          setSuggestApiCalled(false);
          setDebounceFunctionCalledDiagnosis(true);
          if (foundData) {
            handleInputChange("term", updatedFound.term);
          } else {
            handleInputChange("term", updatedSelectedOptiondetsils.term);
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };

  const handleConditionTyped = (value) => {
    setDiagnosisName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  const handleSuggestionClick = (value) => {
    setDiagnosisName(value);
    setSuggestionClicked(true);

    // setKeepSuggestionsVisibleAfterClick(true); // allow options to remain visible
  };

  console.log("Diagnosis data", diagnosis);
  return (
    <ThemeProvider theme={theme}>
      {activeSection && (
        <Grid item xs={12}>
          <Suggestions
            sectionName={sectionName}
            suggestions={suggestions}
            activeSection={activeSection}
            aiSuggestionToggle={aiSuggestionToggle}
            ruleSuggestionToggle={ruleSuggestionToggle}
            handleCrossButtonClick={memoizedHandleCrossButtonClick}
            handleSuggestionClick={handleSuggestionClick}
          />
        </Grid>
      )}
      {activeSection && (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <Grid
              container
              spacing={2}
              sx={{
                marginTop: "5px",
                padding: "10px",
              }}
            >
              <Grid item xs={12} sm={12} md={4}>
                <StyledTextField
                  value={
                    // newDiagnosis.term !== "" ? newDiagnosis.term :
                    diagnosisName
                  }
                  onChange={(e) => {
                    // if (!newDiagnosis.term) {
                    //   setDiagnosisName(e.target.value);
                    // }
                    handleConditionTyped(e.target.value);
                  }}
                  onBlur={() => {
                    setTimeout(() => {
                      const shouldClear =
                        !mouseDownOnOption && !suggestionClicked;

                      if (shouldClear) {
                        // setIsFocused(false);
                        setFilteredOptions([]);
                        setDebounceFunctionCalledDiagnosis(false);
                        setTermSelectedOrAdded(false);
                      }

                      setMouseDownOnOption(false);
                      setSuggestionClicked(false); // Reset
                    }, 100);
                  }}
                  onFocus={() => {
                    // setIsFocused(true);
                    if (diagnosisName.trim() !== "") {
                      debouncedFilterCall(diagnosisName.toLowerCase()); // re-trigger filtering
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div style={{ marginRight: "5px" }}>
                          <Tooltip title="Clear">
                            <OutlinedIconFab
                              size="small"
                              variant="contained"
                              onClick={handleClearDiagnosisName}
                            >
                              <Icon name="clearTextField" size={32} />
                            </OutlinedIconFab>
                          </Tooltip>
                        </div>
                        {/* {!termSelectedOrAdded && (
                        <Tooltip title="Add" style={{ marginRight: "5px" }}>
                          <OutlinedIconFab
                            size="small"
                            variant="contained"
                            onClick={handleAddOption}
                          >
                            <AddIcon />
                          </OutlinedIconFab>
                        </Tooltip>
                      )} */}
                        <>
                          {isAiEnabled &&
                            (listeningOn === false ? (
                              <Tooltip title="Start Listening">
                                <OutlinedIconFab
                                  // onClick={startListening}
                                  onClick={() => {
                                    startRecording();
                                    setListeningOn(true);
                                  }}
                                  variant="contained"
                                  // color="defaultColor"
                                  size="small"
                                >
                                  <Icon name="micNotInUse" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Stop Listening">
                                <OutlinedIconFab
                                  onClick={() => {
                                    // SpeechRecognition.stopListening();
                                    stopRecording("Diagnosis");
                                    setListeningOn(false);
                                  }}
                                  variant="outlined"
                                  // color="defaultColor"
                                  size="small"
                                >
                                  <Icon name="micInUse" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            ))}
                        </>
                      </div>
                    ),
                  }}
                  label="Diagnosis Name"
                  fullWidth
                  error={!!validationErrors.term} // Highlight field in red if there's an error
                  helperText={validationErrors.term} // Show error message
                />
                {filteredOptions.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: "10px",
                      padding: "20px",
                      maxHeight: "200px", // Set your desired maximum height here
                      overflowY: "auto", // Add vertical scrolling
                    }}
                  >
                    {/* Display filtered medicines */}
                    {suggestApiCalled && (
                      <div style={{ color: "red" }}>
                        No Exact Matches found ! You can search for the
                        following Suggestions.
                      </div>
                    )}

                    <>
                      {filteredOptions.map((op) => (
                        <div key={op}>
                          {
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {op.added ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <StyledButton
                                    color="success"
                                    sx={{
                                      textAlign: "left",
                                      justifyContent: "flex-start",
                                      width: "100%",
                                    }}
                                  >
                                    {op.term}
                                  </StyledButton>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      flexDirection: "row",
                                      color: "green",
                                      fontStyle: "bold",
                                    }}
                                  >
                                    <span>&#10003;</span>
                                    <span>(Added)</span>
                                  </div>
                                </div>
                              ) : (
                                <StyledButton
                                  color="grey"
                                  sx={{
                                    textAlign: "left",
                                    justifyContent: "flex-start",
                                    width: "100%",
                                  }}
                                  onClick={() => {
                                    skipEffect.current = true; // prevent debounce call
                                    optionChosen.current = true;
                                    setDiagnosisName(op.term);
                                    handleInputChange("term", op.term);
                                  }}
                                  onMouseDown={() => setMouseDownOnOption(true)}
                                >
                                  {op.term}
                                </StyledButton>
                              )}
                            </div>
                          }
                        </div>
                      ))}
                    </>
                  </div>
                ) : filteredOptions.length == 0 &&
                  debounceFunctionCalledDiagnosis &&
                  !termSelectedOrAdded ? (
                  <div
                    style={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: "10px",
                      padding: "20px",
                      maxHeight: "300px", // Set your desired maximum height here
                      overflowY: "auto", // Add vertical scrolling
                    }}
                  >
                    <div style={{ color: "red" }}>No Options Found!</div>
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <StyledTextField
                  type="number"
                  value={newDiagnosis.duration}
                  error={!!validationErrors.duration}
                  helperText={validationErrors.duration}
                  onChange={(e) =>
                    handleInputChange("duration", e.target.value)
                  }
                  label="Duration"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <StyledTextField
                  select
                  value={newDiagnosis.durationType || "days"}
                  onChange={(e) =>
                    handleInputChange("durationType", e.target.value)
                  }
                  placeholder="Select Duration Type"
                  fullWidth
                  label="Duration Type"
                >
                  {durationType.map((type) => (
                    <MenuItem
                      key={type.value}
                      value={type.value}
                      sx={{ fontSize: "12px" }}
                    >
                      {type.display}
                    </MenuItem>
                  ))}
                </StyledTextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <StyledMultilineTextField
                  value={newDiagnosis.clinical_note}
                  onChange={(e) =>
                    handleInputChange("clinical_note", e.target.value)
                  }
                  placeholder="Clinical Notes"
                  fullWidth
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={1}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <StyledButton
                  onClick={editingIndex != null ? handleUpdate : handleAdd}
                  variant="contained"
                  sx={{
                    fontSize: { xs: "0.8rem", sm: "1rem" },
                    width: "100%",
                  }}
                  bgColor="#0E3F66"
                >
                  {editingIndex != null ? "Update" : "Add"}
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
      {diagnosis && (
        <DiagnosisTable
          data={diagnosis}
          activeSection={activeSection}
          handleEditRow={handleEditRow}
          handleDeleteRow={handleDeleteRow}
        />
      )}
    </ThemeProvider>
  );
};

export default Diagnosis;
